import { homepageRoutes } from "modules/Homepage/route";
import { personnelInformationRoutes } from "modules/PersonnelInformation/route";
import { workPerformanceRoutes } from "modules/WorkPerformance/route";
import { declareLeaveRoutes } from "modules/DeclareLeave/route";
import { personnelFormRoutes } from "modules/PersonnelForm/route";
import { regulationsRoutes } from "modules/Regulations/route";
import { internalCultureRoutes } from "modules/InternalCulture/route";
import { newsRoutes } from "modules/News/route";
import { eventRoutes } from "modules/Event/route";
import { birthdayRoutes } from "modules/Birthday/route";
import { viewRoute } from "modules/ViewComponents/route";
import { researchReportRoutes } from "modules/ResearchReport/route";
import { operationProcessRoutes } from "modules/OperationProcess/route";
import { internalDocumentRoutes } from "modules/InternalDocuments/route";
import { authorizationDocumentRoutes } from "modules/AuthorizationDocument/route";
import { recruitmentRoutes } from "modules/Recruitment/route";
import { evaluationRoutes } from "modules/Evaluation/route";
import { salaryRoutes } from "modules/Salary/route";
import { mbsBirthday26Route } from "modules/Birthday26/route";

const appRoutes: any = [
  ...recruitmentRoutes,
  ...homepageRoutes,
  ...personnelInformationRoutes,
  ...workPerformanceRoutes,
  ...operationProcessRoutes,
  ...declareLeaveRoutes,
  ...personnelFormRoutes,
  ...regulationsRoutes,
  ...viewRoute,
  ...internalCultureRoutes,
  ...newsRoutes,
  ...eventRoutes,
  ...birthdayRoutes,
  ...researchReportRoutes,
  ...internalDocumentRoutes,
  ...authorizationDocumentRoutes,
  ...evaluationRoutes,
  ...salaryRoutes,
  ...mbsBirthday26Route,
];

export default appRoutes;
